import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { phoneNumberValidator } from 'src/app/shared/custom-validators/phone-number.validator';
import { checkForFormFieldErrors } from 'src/app/shared/helpers/form-errors';
import { MessageDisplayModel } from 'src/app/shared/message/messageDisplay.model';
import { User } from 'src/app/shared/models/user.model';
import { InternationalPhonePipe } from 'src/app/shared/pipes/international-phone.pipe';
import { NoSpaceIntPhonePipe } from 'src/app/shared/pipes/no-space-int-phone.pipe';
import { MessageDisplayService } from 'src/app/shared/services/message-display.service';
import { MyProfileService } from 'src/app/shared/services/my-profile.service';
import { COUNTRIES } from 'src/utilities/constants/misc.constants';
import { NUM_AND_SPACE } from 'src/utilities/constants/number-and-space.regex';
import { phoneNumberNFValidator } from 'src/app/shared/custom-validators/phone-number.validator';

@Component({
  selector: 'my-profile-form',
  templateUrl: './my-profile-form.component.html',
  styleUrls: ['./my-profile-form.component.scss']
})
export class MyProfileFormComponent implements OnInit {
  @Input()
  public isWaiting: boolean;

  public user: User;
  public roleName;
  public companyId;
  rolesMap: Object = {};
  roles: string[] = [];
  public defaultWorkPhoneFlag: string;
  public defaultMobilePhoneFlag: string;

  public hasSubmitted = false;
  public myProfileForm: FormGroup;
  public hasFormBeenSubmitted = false;
  public messageDisplay: MessageDisplayModel = new MessageDisplayModel();
  public workPhoneCode: string;
  public mobilePhoneCode: string;
  public invalidMobilePhone = false;
  public invalidWorkPhone = false;

  public countries = COUNTRIES;

  public countryFlags = this.countries.map(e => e.flag);
  public countryCodes = this.countries.map(e => e.code);
  public countryNames = this.countries.map(e => e.name);

  constructor(private fb: FormBuilder,
              private messageDisplayService: MessageDisplayService,
              private myProfileService: MyProfileService,
              private intPhonePipe: InternationalPhonePipe,
              private noSpaceIntPhonePipe: NoSpaceIntPhonePipe) { }

  ngOnInit() {
    this.messageDisplayService.clearMessage();
    this.buildForm();
    this.myProfileForm.valueChanges.subscribe(val => {
      if (this.mobilePhoneCode === '+1') {
        const maskedVal = this.intPhonePipe.transform(val.mobilePhone);
        if (val.mobilePhone !== maskedVal) {
          this.myProfileForm.patchValue({mobilePhone: maskedVal});
        }
      } else {
        const maskedVal = this.noSpaceIntPhonePipe.transform(val.mobilePhone);
        if (val.mobilePhone !== maskedVal) {
          this.myProfileForm.patchValue({mobilePhone: maskedVal});
        }
      }
      if (this.workPhoneCode === '+1') {
        const maskedVal = this.intPhonePipe.transform(val.workPhone);
        if (val.workPhone !== maskedVal) {
          this.myProfileForm.patchValue({workPhone: maskedVal});
        }
      } else {
        const maskedVal = this.noSpaceIntPhonePipe.transform(val.workPhone);
        if (val.workPhone !== maskedVal) {
          this.myProfileForm.patchValue({workPhone: maskedVal});
        }
      }
    });
    this.myProfileService.getSelf().then( res => {
      this.loadData(res);
    });
  }

  buildForm() {
    this.myProfileForm = this.fb.group({
      name: ['', Validators.required],
      jobTitle: ['', Validators.required],
      email: ['', []],
      workPhone: ['', [Validators.required, Validators.pattern(NUM_AND_SPACE)]],
      mobilePhone: ['', []]
    });
  }

  loadData(user: User) {
    console.log('User: ', user);
    if (!!user.mobilePhone && user.mobilePhone.length > 10) {
      const phoneCode = user.mobilePhone.split(' ').join('').split('-').join('').split('(').join('').split(')').join('').slice(0, user.mobilePhone.length - 10);
      this.defaultMobilePhoneFlag = this.countryFlags[this.countryCodes.indexOf(phoneCode)];
    } else {
      this.defaultMobilePhoneFlag = '🇺🇸';
    }
    if (!!user.workPhone && user.workPhone.length > 10) {
      const phoneCode = user.workPhone.split(' ').join('').split('-').join('').split('(').join('').split(')').join('').slice(0, user.workPhone.length - 10);
      this.defaultWorkPhoneFlag = this.countryFlags[this.countryCodes.indexOf(phoneCode)];
    } else {
      this.defaultWorkPhoneFlag = '🇺🇸';
    }
    this.myProfileForm.patchValue({
      name: user.name,
      jobTitle: user.jobTitle,
      email: user.email,
      workPhone: user.workPhone,
      mobilePhone: user.mobilePhone ? user.mobilePhone : null
    });
  }

  public setWorkPhoneCode(flag) {
    this.workPhoneCode = this.countryCodes[this.countryFlags.indexOf(flag)];
  }

  public setMobilePhoneCode(flag) {
    this.mobilePhoneCode = this.countryCodes[this.countryFlags.indexOf(flag)];
  }

  public shouldFormFieldShowAnError(field) {
    return checkForFormFieldErrors(field, this.hasFormBeenSubmitted);
  }

  private includePhoneCode(phoneCode: string, phoneNumber: string): string {
    if (phoneNumber && phoneNumber.startsWith(phoneCode)) {
      return phoneNumber;
    } else {
      return `${phoneCode} ${phoneNumber}`;
    }
  }

  onFormSubmit() {
    this.hasSubmitted = true;
    this.isWaiting = true;
    this.invalidMobilePhone = false;
    this.invalidWorkPhone = false;
    this.messageDisplayService.clearMessage();
    this.messageDisplay = null;
    if (!this.myProfileForm.valid) {
      if (this.myProfileForm.value.workPhone === '') {
        this.invalidWorkPhone = true;
      }
      console.log(this.myProfileForm);
      this.messageDisplay = this.messageDisplayService.createErrorMessageDisplayWithGivenMessage('Please complete the required fields');
      this.isWaiting = false;
      return;
    }
    if (this.myProfileForm.valid) {

      const data: any = this.myProfileForm.value;

      data.workPhone = this.includePhoneCode(this.workPhoneCode, data.workPhone);
      if (data.mobilePhone) {
        data.mobilePhone = this.includePhoneCode(this.mobilePhoneCode, data.mobilePhone);
      } else {
        data.mobilePhone = '';
      }

      if (data.workPhone) {
        data.workPhone =
          data.workPhone.split('').filter(c => c !== ' ').join('').split('').filter(c => c !== '-')
            .join('').split('').filter(c => c !== '(').join('').split('').filter(c => c !== ')').join('');

        if (phoneNumberNFValidator(data.workPhone) != null) {
          this.invalidWorkPhone = true;
          console.log('Invalid work Phone Error');
        }

      }

      if (data.mobilePhone) {
        data.mobilePhone = data.mobilePhone.split('').filter(c => c !== ' ').join('').split('')
          .filter(c => c !== '-').join('').split('').filter(c => c !== '(').join('').split('').filter(c => c !== ')').join('');

        if (phoneNumberNFValidator(data.mobilePhone) != null) {
          this.invalidMobilePhone = true;
          console.log('Invalid mobile Phone Error');
        }

      } else if (data.mobilePhone === '' || data.mobilePhone === undefined) {
        data.mobilePhone = null;
      }

      if (this.invalidWorkPhone || this.invalidMobilePhone) {
        return;
      }

      this.myProfileService.updateSelf(data)
        .then(() => {
          this.hasSubmitted = false;
          this.isWaiting = false;
          this.messageDisplay = this.messageDisplayService.createSuccessMessageDisplayWithGivenMessage(
            'Saved!');
        }, () => {
          this.hasSubmitted = false;
          this.isWaiting = false;
          this.messageDisplay = this.messageDisplayService.createErrorMessageDisplay('GENERIC_PROBLEM');
        });
    }
  }

  shouldDisable() {
    return this.myProfileForm.hasError('required', ['name']) ||
           this.myProfileForm.hasError('required', ['jobTitle']) ||
           this.myProfileForm.hasError('required', ['workPhone']) ||
           this.myProfileForm.hasError('required', ['mobilePhone']);
  }
}
